export default __webpack_public_path__ + "static/media/etc02.40c9bd5d.png";